"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var buttonStyles = {
  display: ["block", "block", "inline"],
  tag: "div"
};

var ExpandButton = function ExpandButton(_ref) {
  var children = _ref.children,
      fontSize = _ref.fontSize,
      titleColor = _ref.titleColor,
      toggleTruncate = _ref.toggleTruncate;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    fontSize: fontSize,
    onClick: toggleTruncate
  }, buttonStyles), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: titleColor || "text-hover",
    cursor: "pointer",
    fontSize: 4,
    fontWeight: 2,
    lineHeight: 3
  }, children));
};

ExpandButton.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  fontSize: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, _propTypes.array]),
  titleColor: _propTypes.string,
  toggleTruncate: _propTypes.func
};

var Truncate = function Truncate(_ref2) {
  var buttonText = _ref2.buttonText,
      description = _ref2.description,
      display = _ref2.display,
      font = _ref2.font,
      showEllipsis = _ref2.showEllipsis,
      titleColor = _ref2.titleColor,
      toggleTruncate = _ref2.toggleTruncate;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    display: display
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    tag: "div"
  }, font), /*#__PURE__*/_react["default"].createElement(_primitives["default"].RawHtml, {
    html: description,
    tag: "span"
  })), showEllipsis && /*#__PURE__*/_react["default"].createElement(ExpandButton, {
    fontSize: font.f,
    titleColor: titleColor,
    toggleTruncate: toggleTruncate
  }, buttonText));
};

Truncate.propTypes = {
  buttonText: _propTypes.string,
  description: _propTypes.string,
  display: (0, _propTypes.arrayOf)(_propTypes.string),

  /** An object used for font styling */
  font: _utils.fontPropType,
  showEllipsis: _propTypes.bool,
  titleColor: _propTypes.string,
  toggleTruncate: _propTypes.func
};
Truncate.displayName = "Modules.Truncate";
var _default = Truncate;
exports["default"] = _default;